import React from 'react'
import {css} from '@emotion/core'
import AnonViewWhiteIcon from '../../images/anon-view-white.svg'

const aboutUsTranslations = require('../../translations/aboutUs.json')

const BackgroundSquiggle2 = ({className, fillColor = '#1E222D'}) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="1440"
        height="182"
        viewBox="0 636 1440 182"
        fill="none"
    >
        <path
            d="M480.668 128C155.416 104 24.701 32.6667 0 0V636C158.22 702 517.719 601 952.323 663C1300.01 712.6 1423.31 795.333 1440 818V280C1367.9 238 887.232 158 480.668 128Z"
            fill={fillColor}
        />
    </svg>
)

const BackgroundSquiggle3 = ({className, fillColor = '#F2F3FF'}) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="1440"
        height="134"
        viewBox="0 0 1440 134"
        fill="none"
    >
        <path
            d="M820.055 92.0531C1080.59 135.569 1341.91 76.7109 1440 0V1340H0V133.895C270.736 -29.2896 535 44.4415 820.055 92.0531Z"
            fill={fillColor}
        />
    </svg>
)

const AboutSubsection2 = ({lang, themeStyles}) => {
    const localizations = aboutUsTranslations[lang]
    const {heading3, copy3, valuePropList3} = localizations
    const verboseLangs = ['nl', 'pl', 'sv', 'no', 'de', 'da', 'es', 'fr', 'pt']
    const isVerboseLang = verboseLangs.includes(lang)
    return (
        <div
            css={css`
                background: ${themeStyles.about.valuePropBackground};
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                overflow: hidden;
            `}
        >
            <BackgroundSquiggle2
                fillColor={themeStyles.about.subsection2TopSquiggleFillColor}
                css={css`
                    width: 100%;
                    height: auto;
                    z-index: 0;
                    pointer-events: none;
                `}
            />
            <h2
                css={css`
                    font-size: 68px;
                    line-height: 76px;
                    font-weight: 700;
                    letter-spacing: -1.36px;
                    color: ${themeStyles.about.valuePropTextColor};
                    margin-bottom: 47px;
                    text-align: center;
                    padding: 0 32px;
                    @media (${themeStyles.breakPoints.mobile}) {
                        max-width: 359px;
                        ${isVerboseLang
                            ? css`
                                  font-size: 42px;
                              `
                            : css`
                                  font-size: 48px;
                              `}
                        line-height: 56px;
                        letter-spacing: -0.96px;
                        margin-bottom: 37px;
                    }
                `}
            >
                {heading3}
            </h2>
            <p
                css={css`
                    font-size: 20px;
                    line-height: 28px;
                    color: ${themeStyles.about.valuePropTextColor};
                    max-width: ${1172 + 64}px;
                    text-align: center;
                    margin-bottom: 80px;
                    padding: 0 32px;
                    @media (${themeStyles.breakPoints.mobile}) {
                        max-width: 327px;
                        margin-bottom: 87px;
                    }
                `}
            >
                {copy3}
            </p>
            <div
                css={css`
                    display: flex;
                    gap: 32px;
                    margin-bottom: 138px;
                    padding: 0 16px;
                    @media (${themeStyles.breakPoints.desktopMedium}) {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 48px;
                    }
                    @media (${themeStyles.breakPoints.tabletSmall}) {
                        gap: 48px 32px;
                    }
                    @media (${themeStyles.breakPoints.mobile}) {
                        display: flex;
                        flex-direction: column;
                        gap: 56px;
                        width: 100%;
                        margin-bottom: 91px;
                    }
                `}
            >
                {valuePropList3.map((item, index) => {
                    const cardTheme = themeStyles.about.cards[index]

                    return (
                        <div
                            key={index}
                            css={css`
                                width: 286px;
                                height: 193px;
                                background: ${cardTheme.backgroundColor};
                                border-radius: 24px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                position: relative;
                                @media (${themeStyles.breakPoints.mobile}) {
                                    width: 100%;
                                    ${isVerboseLang
                                        ? css`
                                              height: 138px;
                                          `
                                        : css`
                                              height: 108px;
                                          `}
                                }
                            `}
                        >
                            <p
                                css={css`
                                    font-size: ${isVerboseLang ? '21px' : '24px'};
                                    font-weight: 700;
                                    line-height: 32px;
                                    color: ${cardTheme.textColor};
                                    max-width: 170px;
                                    text-align: center;
                                    letter-spacing: -0.48px;
                                    margin-bottom: 29px;
                                    @media (${themeStyles.breakPoints.mobile}) {
                                        max-width: none;
                                        padding: 0 38px;
                                        margin-bottom: 24px;
                                    }
                                `}
                            >
                                {item}
                            </p>
                            <div
                                css={css`
                                    width: 64px;
                                    height: 64px;
                                    position: absolute;
                                    background: ${themeStyles.about.cardIconBackground};
                                    border-radius: 50%;
                                    bottom: -24px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    @media (${themeStyles.breakPoints.mobile}) {
                                        bottom: -32px;
                                    }
                                `}
                            >
                                <AnonViewWhiteIcon />
                            </div>
                        </div>
                    )
                })}
            </div>
            <BackgroundSquiggle3
                fillColor={themeStyles.about.subsection2BottomSquiggleFillColor}
                css={css`
                    width: 100%;
                    height: auto;
                    z-index: 0;
                    pointer-events: none;
                `}
            />
        </div>
    )
}

export default AboutSubsection2
